import Color from "@mapmycustomers/shared/enum/Color";
import HasSourceObject from "@mapmycustomers/shared/types/base/HasSourceObject";
import { GeoManagementState } from "@mapmycustomers/shared/types/base/Located";
import { Company, Person } from "@mapmycustomers/shared/types/entity";
import User from "@mapmycustomers/shared/types/User";

const getInitialValues = (
  currentUserId: User["id"],
  sourceObject: HasSourceObject["sourceObject"],
  initialValues?: Partial<Company>,
  fixedPerson?: Person
) => {
  const result = initialValues
    ? {
        cadenceInterval: null,
        color: Color.BLACK,
        contactId: fixedPerson?.id,
        name: initialValues.name,
        phone: initialValues.phone,
        sourceObject,
        user: currentUserId,
        website: initialValues.website,
      }
    : { cadenceInterval: null, sourceObject, user: currentUserId };
  return initialValues
    ? initialValues.address || initialValues.city || !initialValues.geoPoint
      ? {
          ...result,
          addressDetails: {
            address: initialValues.address,
            city: initialValues.city,
            country: initialValues.country,
            countryCode: initialValues.countryCode,
            geoManagementState: GeoManagementState.AUTOMATIC_PRESERVE_ADDRESS,
            postalCode: initialValues.postalCode,
            region: initialValues.region,
            regionCode: initialValues.regionCode,
          },
        }
      : {
          ...result,
          latitude: initialValues.geoPoint.coordinates[1] ?? "",
          longitude: initialValues.geoPoint.coordinates[0] ?? "",
        }
    : result;
};

export default getInitialValues;
